<template>
	<span></span>
</template>

<script setup>
useHead({
	script: [
		{
			src: "/js/silktide-consent-manager.js",
			async: true
		}
	]
});

const { locale } = useI18n();
const cookieConsentConfig = () => {
	return window.silktideCookieBannerManager.updateCookieBannerConfig({
		background: {
			showBackground: true
		},
		position: {
			banner: "bottomLeft"
		},
		cookieIcon: {
			position: "bottomLeft"
		},
		cookieTypes: [
			{
				id: "necessary",
				name: $t("cookies.necessary.title"),
				description: $t("cookies.necessary.description"),
				required: true,
				onAccept: function() {
					window.dispatchEvent(new Event('consentNecessaryAccept'));
				}
			},
			{
				id: "performance",
				name: $t("cookies.performance.title"),
				description: $t("cookies.performance.description"),
				defaultValue: false,
				onAccept: function() {
					window.dispatchEvent(new Event('consentPerformanceAccept'));
				},
				onReject: function() {
					window.dispatchEvent(new Event('consentPerformanceReject'));
				}
			},
			{
				id: "advertising",
				name: $t("cookies.advertising.title"),
				description: $t("cookies.advertising.description"),
				defaultValue: false,
				onAccept: function() {
					window.dispatchEvent(new Event('consentAdvertisingAccept'));
				},
				onReject: function() {
					window.dispatchEvent(new Event('consentAdvertisingReject'));
				}
			}
		],
		text: {
			banner: {
				description: $t("cookies.bar.description"),
				acceptAllButtonText: $t("cookies.bar.acceptAll"),
				acceptAllButtonAccessibleLabel: $t("cookies.bar.acceptAll"),
				rejectNonEssentialButtonText: $t("cookies.bar.deniedAll"),
				rejectNonEssentialButtonAccessibleLabel: $t("cookies.bar.deniedAll"),
				preferencesButtonText: $t("cookies.bar.preferences"),
				preferencesButtonAccessibleLabel: "Toggle preferences"
			},
			preferences: {
				title: $t("cookies.modal.title"),
				description: $t("cookies.modal.description")
			}
		},
		onBackdropOpen: function() {
			document.getElementById("silktide-wrapper").style.display = "flex";
		},
		onPreferencesClose: function() {
			document.getElementById("silktide-wrapper").style.display = "none";
		}
	});
}

watch(locale, async (newId) => {
	cookieConsentConfig();
});

onMounted(() => {
	if (window.silktideCookieBannerManager) {
		cookieConsentConfig();
	}
});
</script>

<style lang="scss">
@use '~/assets/scss/plugins/cookie-consent';
</style>